import { render, staticRenderFns } from "./ReferralPromotionTable.vue?vue&type=template&id=3f2d9fd0&"
import script from "./ReferralPromotionTable.vue?vue&type=script&lang=js&"
export * from "./ReferralPromotionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f2d9fd0')) {
      api.createRecord('3f2d9fd0', component.options)
    } else {
      api.reload('3f2d9fd0', component.options)
    }
    module.hot.accept("./ReferralPromotionTable.vue?vue&type=template&id=3f2d9fd0&", function () {
      api.rerender('3f2d9fd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ReferralPromotionTable.vue"
export default component.exports